// router定義一覧
const ROUTER_TYPE = {
  TOP: {
    path: '/',
    name: 'loginTop',
  },
  LOGIN_TOP: {
    path: '/users/login',
    name: 'loginUserTop',
  },
  LOGIN: {
    path: '/users/login/auth',
    name: 'loginAuth',
  },
  DOWNLOAD: {
    path: '/users/download',
    name: 'download',
  },
  DOWNLOAD_DETAIL: {
    path: '/users/download/:id',
    name: 'downloadDetail',
  },
  ENTRYAUTHSEND: {
    path: '/users/entry/auth/send',
    name: 'entryAuthSend',
  },
  ENTRYAUTH: {
    path: '/users/entry/auth',
    name: 'entryAuth',
  },
  ENTRY: {
    path: '/users/entry',
    name: 'entry',
  },
  USER_EDIT_PASS: {
    path: '/users/settings/password',
    name: 'editPwChange',
  },
  AGREE_LICENSE: {
    path: '/users/entry/agreelicense',
    name: 'agreeTermsOfUse',
  },
  RESET_PASSWORD: {
    path: '/users/reset',
    name: 'resetPwChange',
  },
  NOTFOUNT: {
    path: '/:pathMatch(.*)*',
    name: 'notFound',
  },
  HELP: {
    path: '/help',
    name: 'help',
  },
} as const

export default ROUTER_TYPE
